import { render, staticRenderFns } from "./experimentDetail.vue?vue&type=template&id=22062c19&scoped=true"
import script from "./experimentDetail.vue?vue&type=script&lang=js"
export * from "./experimentDetail.vue?vue&type=script&lang=js"
import style0 from "./experimentDetail.vue?vue&type=style&index=0&id=22062c19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22062c19",
  null
  
)

export default component.exports